module.exports = __webpack_public_path__ + "static/wakeparadise-c6f2ecc1ccdbb9584d4d417c9e1e3546.png";